import * as yup from 'yup'

export const Schema = ({ name, code, note } = {}) => {
    return {
        zone: {
            'Name': { defaultValue: name, field: 'name', validation: yup.string().min(5).required() },
            'Code': { defaultValue: code, field: 'code', validation: yup.string().length(3).required() },
            'Note': { defaultValue: note, field: 'note', validation: yup.string().required() }
        }
    }
}